import { DatePicker, FormField } from '@dev-spendesk/grapes';
import { format } from 'date-fns';

import { getValueDate } from 'src/core/modules/bookkeep/prepare-payables/components/PreparePayablesInbox/utils/date';

type Props = {
  label: string;
  value?: string;
  setFieldValue: (key: string, value: string) => void;
  error: string | undefined;
  minDate?: Date;
};

/**
 * Component responsible for rendering a datepicker field,
 * allowing the user to select a valua for the accounting date field.
 *
 * @param {Props} Props   Component properties, including
 *                        - value (string): the date value
 *                        - setFieldValue (function): the callback function
 *                        - label (string): the label to display
 *                        - error (string): the error message to display
 *                        - minDate (Date): optional minimum allowed date
 * @returns {React.JSX.Element} FormField component
 */
export const PayableAccountingDateField = ({
  label,
  value,
  setFieldValue,
  error,
  minDate,
}: Props) => {
  const accountingDate = value ? getValueDate(value) : undefined;

  return (
    <FormField
      className="PayableForm__accounting-date"
      label={label}
      alertMessage={error}
    >
      <DatePicker
        fit="parent"
        value={accountingDate}
        onChange={(newDate) => {
          if (newDate) {
            setFieldValue('accountingDate', format(newDate, 'yyyy-MM-dd'));
          }
        }}
        minDate={minDate}
      />
    </FormField>
  );
};
